<template>
	<div class="plan-book">
		<headerTemplate title="规划书详情"></headerTemplate>
		<div class="planbook-nav">
			<div class="show-wapper">
				<span>规划书展示</span>
				<span style="color: #409eff;" @click="changeEditSta">
					<van-icon name="edit" />上传规划书
				</span>
			</div>
		</div>
		<div class="planbook-content">
			<van-cell title="店铺用户名" :value="addObj.sellerName" />
			<van-cell title="店铺名称" :value="addObj.storeNam" />
			<van-cell title="店铺地址" :value="addObj.storeUrl" />
			<van-cell title="主营产品类型" :value="addObj.productType" />
			<van-cell title="货源来源" :value="addObj.sourceSupply" />
			<van-cell title="客户群体定位" :value="addObj.customerPosition" />
			<van-cell title="产品数量" :value="addObj.productsNum" />
			<van-cell title="信用等级" :value="addObj.creditRank" />
			<van-cell title="开办费用" :value="addObj.startFunds" />
			<van-cell title="固定资产" :value="addObj.fixedFunds" />
			<van-cell title="流动资金" :value="addObj.flowFunds" />
			<van-cell title="招聘人数" :value="addObj.recruitsNum" />
			<van-cell title="人员分工" :value="addObj.peopleDivision" />
			<van-cell title="选择推广途径与原因(免费)" :value="addObj.promoteFree" />
			<van-cell title="预期效果(免费)" :value="addObj.expectedFree" />
			<van-cell title="选择推广途径与原因(收费)" :value="addObj.promoteCharges" />
			<van-cell title="预计投入(收费)" :value="addObj.expectedInput" />
			<van-cell title="预计产出(收费)" :value="addObj.expectedOutput" />
			<van-cell title="日均访客数" :value="addObj.visitorsNum" />
			<van-cell title="转化率%" :value="addObj.converRate" />
			<van-cell title="日成交访客数" :value="addObj.visitorsDealNum" />
			<van-cell title="课单价" :value="addObj.customerPrice" />
			<van-cell title="总收入" :value="addObj.revenue" />
			<van-cell title="总成本" :value="addObj.totalCost" />
			<van-cell title="净收入" :value="addObj.income" />
		</div>
	</div>
</template>

<script>
	import { planAdd, getPlan } from '../../../api/student'
	import headerTemplate from '@/components/headerTemplate/headerTemplate'

	export default {
		name: 'PlanBook',
		components: {
			headerTemplate
		},
		props: [],
		data() {
			return {
				// 添加
				addObj: {
					sellerName: '',
					storeName: '',
					storeUrl: '',
					productType: '',
					sourceSupply: '',
					customerPosition: '',
					pricePosition: '',
					productsNum: 0,
					creditRank: '',
					startFunds: 0,
					fixedFunds: 0,
					flowFunds: 0,
					recruitsNum: 0,
					peopleDivision: '',
					promoteFree: '',
					expectedFree: '',
					promoteCharges: '',
					expectedInput: 0,
					expectedOutput: 0,
					visitorsNum: 0,
					converRate: 0,
					visitorsDealNum: 0,
					customerPrice: 0,
					revenue: 0,
					totalCost: 0,
					income: 0
				}
			}
		},
		methods: {
			changeEditSta() {
				this.$router.push({
					name: 'PlanBookEdit'
				})
			},
		},
		created() {
			getPlan().then(res => {
				if (res.code === 10000) {
					this.addObj = {
						sellerName: res.result.seller_name,
						storeName: res.result.store_name,
						storeUrl: res.result.store_url,
						productType: res.result.product_type,
						sourceSupply: res.result.source_supply,
						customerPosition: res.result.customer_position,
						pricePosition: res.result.price_position,
						productsNum: res.result.products_num,
						creditRank: res.result.credit_rank,
						startFunds: res.result.start_funds,
						fixedFunds: res.result.fixed_funds,
						flowFunds: res.result.flow_funds,
						recruitsNum: res.result.recruits_num,
						peopleDivision: res.result.people_division,
						promoteFree: res.result.promote_free,
						expectedFree: res.result.expected_free,
						promoteCharges: res.result.promote_charges,
						expectedInput: res.result.expected_input,
						expectedOutput: res.result.expected_output,
						visitorsNum: res.result.visitors_num,
						converRate: res.result.conver_rate,
						visitorsDealNum: res.result.visitors_deal_num,
						customerPrice: res.result.customer_price,
						revenue: res.result.revenue,
						totalCost: res.result.total_cost,
						income: res.result.income
					}
				}
			}).catch(error => {
				this.$router.push('Home')
			})
		}
	}
</script>

<style lang="scss" scoped>
	.plan-book {
		font-size: 12px;

		.planbook-title {
			display: flex;
			align-items: center;
			color: white;
			background-color: #e93b3d;

			.title {
				padding: 10px;
				font-size: 14px;
			}
		}

		.planbook-nav {
			box-shadow: 0 0 5px #E0E0E0;
			margin: 5px 0px;
			padding: 10px 15px;

			.show-wapper {
				display: flex;
				justify-content: space-between;
				align-items: center;
			}

			.edit-wapper {
				display: flex;
				justify-content: space-between;
				align-items: center;

				.edit-return {
					display: flex;
					justify-content: space-around;
					align-items: center;
					color: #409eff;

					.return-font {
						margin-right: 10px;
					}
				}
			}
		}
	}
</style>